function TestimonialsSection() {
  return (
    <section id="testimonials" className="ac-section ac-width ac-reviews">
      <div className="ac-section-lead">
        <h2>Co říkají členové.</h2>
        <div>
          <p>Zkušenosti s Allcomem můžeš sdílet přímo na DISBOARDu. Zajímá nás, co ti sedí i co bychom mohli zlepšit.</p>
          <div className="ac-review-actions">
            <a href="https://disboard.org/server/1325522814895263775" className="ac-button" target="_blank" rel="noopener noreferrer">Recenze na DISBOARDu</a>
            <a href="https://disboard.org/review/create/1325522814895263775" className="ac-text-link" target="_blank" rel="noopener noreferrer">Napsat recenzi na DISBOARDu</a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TestimonialsSection
